import "./styles.scss";

import React from "react";
import clsx from "clsx";

const SimpleContent = ({ title, description, variant }) => {
  return (
    <div
      className={clsx(
        "simple-content",
        variant && `simple-content--${variant}`
      )}
    >
      {title && <h4>{title}</h4>}
      {description && (
        <div
          className="simple-content__description"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
    </div>
  );
};

export default SimpleContent;
